import Title from "../Title";
import "./style.scss";
const Header = () => {
  return (
    <header className="wrapperHeader">
      <Title title="Buscardor de Imagenes Pixabay" />
    </header>
  );
};

export default Header;
